import { Button, Dialog, DialogBody, DialogContent, DialogFooter } from '@civilgrid/ui/components';
import { Action } from '~/authorizations';
import Can from '~/authorizations/Can';
import { captureTypedPosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import { useLandRightsTitleZipsViaS3Enabled } from '~/hooks/useLandRightsTitleZipsViaS3Enabled';
import { singleTitleCost } from '~/pages/projectDetails/landRights/constant';
import { orderTitleReport } from '~/pages/projectDetails/landRights/helper';

interface ConfirmDocumentOrderModalProps {
  isDocModalOpen: boolean;
  setIsDocModalOpen: (IsDocModalOpen: boolean) => void;
  docParams?: { DocId: string; CmtId: string };
  projectId: string;
  currentOrganizationId?: string;
}

export const ConfirmDocumentOrderModal = ({
  isDocModalOpen,
  setIsDocModalOpen,
  docParams,
  projectId,
  currentOrganizationId,
}: ConfirmDocumentOrderModalProps) => {
  const titleZipsViaS3 = useLandRightsTitleZipsViaS3Enabled();
  return (
    <Dialog open={isDocModalOpen} onOpenChange={setIsDocModalOpen}>
      <DialogContent
        title="Order Report"
        className="z-[130] w-auto min-w-min max-w-[75vw] shadow-lg"
        overlayClassName="z-[120]"
        data-testid="land-rights-doc-order-dialog"
      >
        <DialogBody className="text-sm">
          Would you like to order this report at a cost of
          {singleTitleCost.toFormat()}?
        </DialogBody>
        <DialogFooter>
          <Button
            variant="secondary"
            type="reset"
            onClick={() => setIsDocModalOpen(false)}
            data-testid="land-rights-doc-modal-close"
          >
            Close
          </Button>
          <Can action={singleTitleCost.getAmount() > 0 ? Action.OrderPaidReports : Action.OrderFreeReports}>
            <Button
              type="submit"
              data-testid="land-rights-doc-modal-accept"
              onClick={() => {
                orderTitleReport({
                  projectId,
                  docParams,
                  currentOrganizationId,
                  viaSignedUrl: titleZipsViaS3,
                }).then((success) => {
                  captureTypedPosthogEvent(
                    success ? POSTHOG_EVENTS.landRightsDataDownloaded : POSTHOG_EVENTS.landRightsDataDownloadFailed,
                    {
                      project_id: projectId,
                      organization_id: currentOrganizationId,
                      type: 'titleDocument',
                      doc_count: 1,
                    },
                  );
                });
                setIsDocModalOpen(false);
              }}
            >
              Accept
            </Button>
          </Can>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
